import axiosInstance from './AxiosInstance';
import qs from 'qs';


class RegisterManagementReportService {
  constructor() {
    this.endpoint = "/api/registerManagement"
  }

  
  async getVotingCentreReport(params){
      
    try {
      const response = await axiosInstance.get(`${this.endpoint}/report/center`,
      {
          params,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
      });
      return response.data;
  } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
  }
  
}

async getDistricts(params) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/national/districts`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async getConstituenciesByDistrict(params) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/national/constituencies/district`,
        {
          params,
          paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }


async getPollingDivisionsByConstituency(params) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/national/pollingdivisions/constituency`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }

}

async getRegistrationCentresByPollingDivision(params) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/national/registrationcentres/pollingdivision/`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
    return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async getLocalDistricts(params) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/local/districts`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;

  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async getCouncilsByDistrict(params) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/local/Council`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;
  } catch (error) {
    console.error('Error fetching data:', error);
    throw error;
  }
}

async GetLocalVotingDistrictsByCouncilIdAsync(params) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/local/votingdistrict/constituency`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;

  } catch (error) {
    console.error('Error fetkching data:', error);
    throw error;
  }
}
async getPollingStaionByLocalVotingStation(params) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/PollingStations/`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async getLocalVotingStationsByVotingDistrictIDAsync(params) {
    try {
      const response = await axiosInstance.get(`${this.endpoint}/local/votingstation/`,{
      params,
      paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
  });
  return response.data;
    } catch (error) {
      console.error('Error fetching data:', error);
      throw error;
    }
  }

  async viewdownloadDelimitationReport(data) {
    try {
        const response = await axiosInstance.post(`${this.endpoint}/report/center`, data);
        return response.data;
    } catch (error) {
        console.error("Error downloading report:", error);
    }
  }

async downloadDelimitationReport(data) {
  try {
      const response = await axiosInstance.post(`${this.endpoint}/roll`, data);
      return response.data;
  } catch (error) {
      console.error("Error downloading report:", error);
  }
  
}

async downloadFile(data) {
  try {
    const response = await axiosInstance.get(`${this.endpoint}/downloadfile/${data}`,
      {
        responseType: 'blob', 
        paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
      }
    );

    return response.data;
} catch (error) {
    console.error('Error fetching data:', error);
    throw error;
}
}

async publishEventRegister(data) {
  try {
      const response = await axiosInstance.post(`${this.endpoint}/publish`, data);
      return response.data;
  } catch (error) {
      console.error('Error posting data:', error);
      throw error;
  }
}
async downloadVoterRegisterRollReport(data) {
  try {
      const response = await axiosInstance.post(`${this.endpoint}/votersroll`, data);
      return response.data;
  } catch (error) {
      console.error("Error downloading report:", error);
  }
  
}
}
const registerManagementReportService = new RegisterManagementReportService();
export default registerManagementReportService;
